/* eslint-disable react/destructuring-assignment */
import React, { Fragment, useEffect } from 'react';

import { bool, string } from 'prop-types';

import { getTarget } from '../../libs';
import { withLazyLoadConsumer } from '../../libs/lazyLoadProvider';

import { StyledImg, StyledPicture } from './styles';

const Picture = (props) => {
  const { big, large, extralarge, medium, small, defaultSize, title, usePicture, radius } = props;

  return (
    <Fragment>
      {!defaultSize && (
        <StyledImg
          draggable={false}
          src="/images/image-404.png"
          title="Imagem não Encontrada"
          alt="Imagem não Encontrada"
          aria-label="Imagem não Encontrada"
        />
      )}

      {defaultSize && usePicture && (
        <Fragment>
          <StyledPicture>
            {extralarge && <source srcSet={extralarge} media="(min-width: 1281px)" />}
            {large && <source srcSet={large} media="(min-width: 769px)" />}
            {big && <source srcSet={big} media="(min-width: 481px)" />}
            {medium && <source srcSet={medium} media="(min-width: 321px)" />}
            {small && <source srcSet={small} media="(max-width: 320px)" />}

            <StyledImg
              radius={radius}
              draggable={false}
              className="no-lazyload"
              src={props[defaultSize]}
              title={title}
              alt={title}
              aria-label={title}
            />
          </StyledPicture>
        </Fragment>
      )}

      {defaultSize && !usePicture && (
        <Fragment>
          <StyledImg
            radius={radius}
            draggable={false}
            className="no-lazyload"
            src={defaultSize}
            title={title}
            alt={title}
            aria-label={title}
            {...props}
          />
        </Fragment>
      )}
    </Fragment>
  );
};

const LazyPicture = withLazyLoadConsumer((props) => {
  const { big, large, extralarge, medium, small, defaultSize, title, usePicture, lazyLoad, radius } = props;

  useEffect(() => {
    if (lazyLoad) {
      lazyLoad.update();
    }
  }, [lazyLoad]);

  return (
    <Fragment>
      {!defaultSize && (
        <StyledImg
          src="/images/image-404.png"
          title="Imagem não Encontrada"
          alt="Imagem não Encontrada"
          aria-label="Imagem não Encontrada"
        />
      )}

      {defaultSize && usePicture && (
        <Fragment>
          <StyledPicture>
            {extralarge && <source data-srcset={extralarge} media="(min-width: 1281px)" />}
            {large && <source data-srcset={large} media="(min-width: 769px)" />}
            {big && <source data-srcset={big} media="(min-width: 481px)" />}
            {medium && <source data-srcset={medium} media="(min-width: 321px)" />}
            {small && <source data-srcset={small} media="(max-width: 320px)" />}

            <StyledImg
              radius={radius}
              draggable={false}
              className="is-lazyload"
              data-src={props[defaultSize]}
              src="/images/loader.gif"
              title={title}
              alt={title}
              aria-label={title}
            />
          </StyledPicture>
        </Fragment>
      )}

      {defaultSize && !usePicture && (
        <Fragment>
          <StyledImg
            radius={radius}
            draggable={false}
            className="is-lazyload"
            data-src={defaultSize}
            src="/images/loader.gif"
            title={title}
            alt={title}
            aria-label={title}
          />
        </Fragment>
      )}
    </Fragment>
  );
});

Picture.propTypes = {
  big: string,
  large: string,
  extralarge: string,
  medium: string,
  small: string,
  defaultSize: string,
  title: string,
  usePicture: bool,
  radius: string,
};

Picture.defaultProps = {
  usePicture: true,
};

LazyPicture.propTypes = {
  big: string,
  large: string,
  extralarge: string,
  medium: string,
  small: string,
  defaultSize: string,
  title: string,
  usePicture: bool,
  radius: string,
};

LazyPicture.defaultProps = {
  usePicture: true,
};

const Image = ({ linkUrl, title, target, lazyLoad, ...others }) => (
  <Fragment>
    {linkUrl && (
      <a href={linkUrl} title={title} aria-label={title} target={getTarget(target)} rel="noopener">
        {!lazyLoad && <Picture title={title} {...others} />}
        {lazyLoad && <LazyPicture title={title} {...others} />}
      </a>
    )}
    {!linkUrl && (
      <Fragment>
        {!lazyLoad && <Picture title={title} {...others} />}
        {lazyLoad && <LazyPicture title={title} {...others} />}
      </Fragment>
    )}
  </Fragment>
);

Image.propTypes = {
  title: string,
  linkUrl: string,
  target: string,
  small: string,
  medium: string,
  big: string,
  large: string,
  extralarge: string,
  defaultSize: string,
  lazyLoad: bool,
};

Image.defaultProps = {
  title: '',
  linkUrl: null,
  target: null,
  small: null,
  medium: null,
  big: null,
  large: null,
  extralarge: null,
  defaultSize: null,
  lazyLoad: true,
};

export default Image;
